/* eslint-disable quotes */
/* eslint-disable react/require-default-props */
import { CircularProgress } from "@material-ui/core";
import React from "react";
import { ButtonCustom, Small } from "./styles";
import Colors from "../../constants/color";

interface Props {
  onPress: Function;
  text: string;
  backgroundColor?: string;
  textColor?: string;
  isLoading?: boolean;
}

const UnderlineButton: React.FC<Props> = ({
  onPress,
  text,
  backgroundColor,
  textColor,
  isLoading,
}) => (
  <ButtonCustom
    disabled={isLoading}
    style={{ backgroundColor }}
    onClick={() => onPress()}
  >
    {isLoading ? (
      <CircularProgress style={{ color: Colors.white }} size={28} />
    ) : (
      <Small color={textColor}>{text}</Small>
    )}
  </ButtonCustom>
);
export default UnderlineButton;
